/**
 * Identificador temporal de frontend para asociar un firmante con sus campos
 * antes de que exista un id de base de datos. Siempre devuelve un string.
 * crypto.randomUUID solo existe en contextos seguros; en HTTP se usa el respaldo.
 */
export function generateTempId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  const bytes = new Uint8Array(16)
  const time = Date.now()
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes)
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256)
    }
  }
  bytes[0] ^= time & 0xff
  bytes[1] ^= (time >> 8) & 0xff
  bytes[2] ^= (time >> 16) & 0xff
  bytes[3] ^= (time >> 24) & 0xff
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
